__turbopack_context__.v({
  "checkIcon": "FeatureList-module__0NFieq__checkIcon",
  "divider": "FeatureList-module__0NFieq__divider",
  "feature": "FeatureList-module__0NFieq__feature",
  "featureContent": "FeatureList-module__0NFieq__featureContent",
  "featureListContainer": "FeatureList-module__0NFieq__featureListContainer",
  "featureTitle": "FeatureList-module__0NFieq__featureTitle",
  "head": "FeatureList-module__0NFieq__head",
  "imageContainer": "FeatureList-module__0NFieq__imageContainer",
  "planTenureTotalPrice": "FeatureList-module__0NFieq__planTenureTotalPrice",
  "planWrapper": "FeatureList-module__0NFieq__planWrapper",
  "popularTag": "FeatureList-module__0NFieq__popularTag",
  "pricingContainer": "FeatureList-module__0NFieq__pricingContainer",
  "subhead": "FeatureList-module__0NFieq__subhead",
  "textContainer": "FeatureList-module__0NFieq__textContainer",
  "topSection": "FeatureList-module__0NFieq__topSection",
  "xlDivider": "FeatureList-module__0NFieq__xlDivider",
  "yearlyPrice": "FeatureList-module__0NFieq__yearlyPrice",
});
